"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AccountType;
(function (AccountType) {
    AccountType[AccountType["Internal"] = 0] = "Internal";
    AccountType[AccountType["Schools"] = 1] = "Schools";
    AccountType[AccountType["PWS"] = 2] = "PWS";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
//# sourceMappingURL=AccountType.js.map